export default __webpack_public_path__ + "e5e9d5d1ae0e0298306b5029d58cadec.png";